export default "__VITE_ASSET__BlHMaRX6__"